export interface SourceAttribution {
  href: string
  hostname: string
}

/** A recorded third-party source; never infer a source from the article text. */
export function parseSourceAttribution(value: unknown): SourceAttribution | null {
  if (typeof value !== 'string' || /[\u0000-\u001f\u007f\\]/.test(value)) return null
  const input = value.trim()
  if (!input) return null
  const authority = /^https?:\/\/([^/?#]+)/i.exec(input)?.[1]
  if (!authority || authority.includes('@')) return null

  try {
    const url = new URL(input)
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null
    const hostname = url.hostname.toLowerCase().replace(/\.$/, '').replace(/^www\./, '')
    if (!hostname || hostname === 'haber.com' || hostname.endsWith('.haber.com')) return null
    return { href: url.href, hostname }
  } catch {
    return null
  }
}
